import { FunctionComponent } from 'react';

import { HomeFullPageProps, HomeStepType } from 'scenes/home/types';

import {
  PolicyStartDateStep,
  CoverTypeSelectionStep,
  RiskAddressStep,
  OwnershipStep,
  PropertyUsedForBusinessStep,
  PropertyBusinessTypeStep,
  PropertyPurposeStep,
  KickOutStep,
  PersonalOrBusinessPolicyStep,
  ContactDateOfBirthStep,
  RecentInsurerStep,
  YearsInsuredStep,
  ClaimsMadeStep,
  BuildingTypeStep,
  BreakInAndAdditionalSecurityStep,
  NumberOfBedroomsStep,
  PropertyBuiltYearStep,
  RoofMaterialStep,
  WallMaterialStep,
  SecurityFeaturesStep,
  SumInsuredChoiceStep,
  SumInsuredBuildingValueStep,
  SumInsuredContentsValueStep,
  FlybuysStep,
  QuotePriceStep,
  BuildingExcessStep,
  ContentsExcessStep,
  OptionalExtrasStep,
  SpecifiedContentsAnswerStep,
  SpecifiedContentListStep,
  AddSpecifiedContentStep,
  UnspecifiedPortableContentsStep,
  PropertyConditionStep,
  PropertyUnoccupiedStep,
  PropertyRenovationStep,
  Over5AcresStep,
  PropertyOccupancyStep,
  OccupantsHistoryStep,
  MortgageProviderStep,
  ContactEmailAddressStep,
  ContactPhoneNumberStep,
  MarketingConsentStep,
  TermsAndConditionsStep,
  PostalAddressStep,
  DifferentPostalAddressManualStep,
  DifferentPostalAddressStep,
  LockedBagAddressStep,
  PersonalPolicyContactStep,
  AddAdditionalPolicyHolderStep,
  AdditionalPolicyHolderStep,
  AdditionalPolicyHolderListStep,
  BusinessNameAndAbnStep,
  BusinessContactStep,
  HeritageListedStep,
  RewiredOrReplumbedStep,
  SummaryStep,
  PaymentFrequencyStep,
  PaymentDateStep,
  PromoCodeStep,
  PaymentMethodStep,
  DirectDebitPaymentStep,
  CreditCardPaymentStep,
  PaymentConfirmationStep,
  ReviewPolicyStartDateStep,
  CashKeptAtHomeStep,
  StockKeptAtHomeStep,
  HazardGoodsKeptAtHomeStep,
  NumberOfVisitsStep,
  BusinessRegisteredForGstStep,
} from '.';

const stepRoutes: {
  [s in HomeStepType]: FunctionComponent<HomeFullPageProps>;
} = {
  [HomeStepType.CoverTypeSelection]: CoverTypeSelectionStep,
  [HomeStepType.PolicyStartDate]: PolicyStartDateStep,
  [HomeStepType.RiskAddress]: RiskAddressStep,
  [HomeStepType.Ownership]: OwnershipStep,
  [HomeStepType.PropertyUsedForBusiness]: PropertyUsedForBusinessStep,
  [HomeStepType.PropertyBusinessType]: PropertyBusinessTypeStep,
  [HomeStepType.PropertyPurpose]: PropertyPurposeStep,
  [HomeStepType.KickOutChoice]: KickOutStep,
  [HomeStepType.PersonalOrBusinessPolicy]: PersonalOrBusinessPolicyStep,
  [HomeStepType.ContactDateOfBirth]: ContactDateOfBirthStep,
  [HomeStepType.RecentInsurer]: RecentInsurerStep,
  [HomeStepType.YearsInsured]: YearsInsuredStep,
  [HomeStepType.ClaimsMade]: ClaimsMadeStep,
  [HomeStepType.BuildingType]: BuildingTypeStep,
  [HomeStepType.BreakInAndAdditionalSecurity]: BreakInAndAdditionalSecurityStep,
  [HomeStepType.NumberOfBedrooms]: NumberOfBedroomsStep,
  [HomeStepType.PropertyBuiltYear]: PropertyBuiltYearStep,
  [HomeStepType.RoofMaterial]: RoofMaterialStep,
  [HomeStepType.WallMaterial]: WallMaterialStep,
  [HomeStepType.SecurityFeatures]: SecurityFeaturesStep,
  [HomeStepType.SumInsuredChoice]: SumInsuredChoiceStep,
  [HomeStepType.SumInsuredBuildingValue]: SumInsuredBuildingValueStep,
  [HomeStepType.SumInsuredContentsValue]: SumInsuredContentsValueStep,
  [HomeStepType.FlybuysNumber]: FlybuysStep,
  [HomeStepType.PromoCode]: PromoCodeStep,
  [HomeStepType.QuotePrice]: QuotePriceStep,
  [HomeStepType.BuildingExcess]: BuildingExcessStep,
  [HomeStepType.ContentsExcess]: ContentsExcessStep,
  [HomeStepType.OptionalExtras]: OptionalExtrasStep,
  [HomeStepType.SpecifiedContentsAnswer]: SpecifiedContentsAnswerStep,
  [HomeStepType.SpecifiedContentList]: SpecifiedContentListStep,
  [HomeStepType.AddSpecifiedContent]: AddSpecifiedContentStep,
  [HomeStepType.UnspecifiedPortableContents]: UnspecifiedPortableContentsStep,
  [HomeStepType.PropertyCondition]: PropertyConditionStep,
  [HomeStepType.HeritageListed]: HeritageListedStep,
  [HomeStepType.RewiredOrReplumbed]: RewiredOrReplumbedStep,
  [HomeStepType.PropertyUnoccupied]: PropertyUnoccupiedStep,
  [HomeStepType.PropertyRenovation]: PropertyRenovationStep,
  [HomeStepType.Over5Acres]: Over5AcresStep,
  [HomeStepType.PropertyOccupancy]: PropertyOccupancyStep,
  [HomeStepType.CashKeptAtHome]: CashKeptAtHomeStep,
  [HomeStepType.StockKeptAtHome]: StockKeptAtHomeStep,
  [HomeStepType.HazardGoodsKeptAtHome]: HazardGoodsKeptAtHomeStep,
  [HomeStepType.NumberOfVisits]: NumberOfVisitsStep,
  [HomeStepType.BusinessRegisteredForGst]: BusinessRegisteredForGstStep,
  [HomeStepType.OccupantsHistory]: OccupantsHistoryStep,
  [HomeStepType.MortgageProvider]: MortgageProviderStep,
  [HomeStepType.BusinessNameAndAbn]: BusinessNameAndAbnStep,
  [HomeStepType.BusinessContact]: BusinessContactStep,
  [HomeStepType.PersonalPolicyContact]: PersonalPolicyContactStep,
  [HomeStepType.ContactEmailAddress]: ContactEmailAddressStep,
  [HomeStepType.ContactPhoneNumber]: ContactPhoneNumberStep,
  [HomeStepType.AddAdditionalPolicyHolder]: AddAdditionalPolicyHolderStep,
  [HomeStepType.AdditionalPolicyHolder]: AdditionalPolicyHolderStep,
  [HomeStepType.AdditionalPolicyHolderList]: AdditionalPolicyHolderListStep,
  [HomeStepType.PostalAddress]: PostalAddressStep,
  [HomeStepType.DifferentPostalAddress]: DifferentPostalAddressStep,
  [HomeStepType.DifferentPostalAddressManual]: DifferentPostalAddressManualStep,
  [HomeStepType.LockedBagAddress]: LockedBagAddressStep,
  [HomeStepType.MarketingConsent]: MarketingConsentStep,
  [HomeStepType.TermsAndConditions]: TermsAndConditionsStep,
  [HomeStepType.Summary]: SummaryStep,
  [HomeStepType.AdditionalPolicyHolder]: AdditionalPolicyHolderStep,
  [HomeStepType.PaymentFrequency]: PaymentFrequencyStep,
  [HomeStepType.PaymentDate]: PaymentDateStep,
  [HomeStepType.PaymentMethod]: PaymentMethodStep,
  [HomeStepType.DirectDebitPayment]: DirectDebitPaymentStep,
  [HomeStepType.CreditCardPayment]: CreditCardPaymentStep,
  [HomeStepType.PaymentConfirmation]: PaymentConfirmationStep,
  [HomeStepType.ReviewPolicyStartDate]: ReviewPolicyStartDateStep,
};

export default stepRoutes;
